import script from "./Popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Popup.vue?vue&type=script&setup=true&lang=js"

import "./Popup.vue?vue&type=style&index=0&id=1c4b2562&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4b2562"]])

export default __exports__